import React, { useState, useEffect } from "react";
import { Form, Col, Button, Tooltip, OverlayTrigger, Row, Container } from 'react-bootstrap';
import { useDispatch } from 'redux-react-hook';
import { InfoCircle } from 'react-bootstrap-icons';

export default function RandomSetting(props) {
    const questionIndex = props.index;
    // const data = props.data || { is_rand: 0, rand: [], ty: 0 };
    const [data, setData] = useState(props.data || { is_rand: 0, rand: [], ty: 0 });
    const dispatch = useDispatch();
    const isDebug = false;

    function logDebug(content) {
        if (isDebug) console.log(content);
    }

    useEffect(() => {
        logDebug(props.data)
        let tmpData = { ...props.data };
        if (tmpData && tmpData.is_rand
            && tmpData.is_rand == 1 && tmpData.rand
            && tmpData.rand == []) {
            tmpData.is_rand = 0
        }
        if (tmpData.is_rand == 1 && null == tmpData.ty) {
            tmpData.ty = 0;
        }
        setData(tmpData);
    }, [props.data]);

    function onSelect(e) {
        try {
            let tmp = parseInt(e.currentTarget.value);
            if (false == isNaN(tmp)) {
                logDebug(tmp);
                dispatch({
                    type: "QUESTION_SET_RANDOM",
                    index: questionIndex,
                    data: { is_rand: tmp, ty: data.ty, rand: data.rand || [] }
                });
            }
        } catch (e) {

        }
    }

    function onCustomOptChanged(e, index, index2, isStart) {
        try {
            let tmp = parseInt(e.currentTarget.value);
            if (false == isNaN(tmp)) {
                tmp = (tmp <= 0) ? 0 : tmp - 1;
                let tmpAry = [...data.rand];
                let lastIndex = tmpAry[index].length - 1;
                let last, first;
                // console.log(JSON.stringify(tmpAry), e.currentTarget.value, index, index2, isStart, lastIndex);
                if (true == isStart) {
                    // console.log(tmpAry[index][lastIndex], tmp);
                    if (tmpAry[index][lastIndex] < tmp) {
                        last = tmp;
                        first = tmpAry[index][lastIndex];
                    } else {
                        last = tmpAry[index][lastIndex];
                        first = tmp;
                    }
                }
                else {
                    if (tmpAry[index][0] > tmp) {
                        last = tmpAry[index][0];
                        first = tmp;
                    } else {
                        last = tmp;
                        first = tmpAry[index][0];
                    }
                }
                let result = [];
                if (last != first) {
                    for (let i = first; i <= last; i++) {
                        result.push(i);
                    };
                } else {
                    result = [first, last];
                }
                tmpAry[index] = result;
                // console.log(tmpAry);
                logDebug(tmp, e.currentTarget, tmpAry);
                dispatch({
                    type: "QUESTION_SET_RANDOM",
                    index: questionIndex,
                    data: { ...data, rand: tmpAry }
                });
            }
        } catch (e) {
            console.warn(e.stack);
        }
    }

    function onCustomOptRemoved(index) {
        // console.log(e.currentTarget.value);
        try {
            let tmpAry = [...data.rand];
            tmpAry.splice(index, 1);
            logDebug(tmpAry);
            dispatch({
                type: "QUESTION_SET_RANDOM",
                index: questionIndex,
                data: { ...data, rand: tmpAry }
            });
        } catch (e) {
            console.warn(e.stack);
        }
    }

    function onCustomOptAdded(e) {
        let tmpAry = [...data.rand];
        tmpAry.push([0, 0]);
        dispatch({
            type: "QUESTION_SET_RANDOM",
            index: questionIndex,
            data: { ...data, rand: tmpAry }
        });
    }

    function onRamSubSelect(e) {
        try {
            let tmp = parseInt(e.currentTarget.value);
            if (false == isNaN(tmp)) {
                // setSubOpt(tmp);

                // console.log("TBD", tmp);
                if (0 == tmp) {
                    dispatch({
                        type: "QUESTION_SET_RANDOM",
                        index: questionIndex,
                        data: { ...data, ty: tmp, rand: [] }
                    });
                } else {
                    dispatch({
                        type: "QUESTION_SET_RANDOM",
                        index: questionIndex,
                        data: { ...data, ty: 1, rand: [[0, 1]] }
                    });
                }
            }
        } catch (e) {

        }
    }

    function render() {
        // console.log(subOpt);
        let tmp = <></>;
        if (data && data.is_rand == 1) {
            let customOpt = [];
            //rand: [[0, 1], [2, 3]]
            customOpt.push(
                <Row key={"rnh"}>
                    <Col xs={2}></Col>
                    <Col xs={3}>選項號(最低)</Col>
                    <Col xs={3}>選項號(最高)</Col>
                    <Col xs={3}></Col>
                </Row>
            );
            for (let i = 0; i < data.rand.length; i++) {
                let lastIndex = data.rand[i].length - 1;
                let val1 = parseInt(data.rand[i][0]);
                let val2 = parseInt(data.rand[i][lastIndex]);
                val1 = isNaN(val1) ? 1 : val1;
                val2 = isNaN(val2) ? 1 : val2;
                customOpt.push(
                    <Row key={"rn" + i}>
                        <Col xs={2}><label>第{i + 1}組</label></Col>
                        <Col xs={3}><input style={{ width: "100%" }} key={i + "-0"} type="number" value={val1 + 1} min={1} max={props.max} onChange={(event) => onCustomOptChanged(event, i, 0, true)} /></Col>
                        <Col xs={3}><input style={{ width: "100%" }} key={i + "-1"} type="number" value={val2 + 1} min={1} max={props.max} onChange={(event) => onCustomOptChanged(event, i, lastIndex, false)} /></Col>
                        <Col xs={3}><Button onClick={(event) => onCustomOptRemoved(i)}>Delete</Button></Col>
                    </Row>
                );
                if (val1 == val2) {
                    customOpt.push(
                        <Row key={"rn" + i + "-note"}>
                            <Col xs={2}></Col>
                            <Col><label className="text-red">組別起始需為範圍不得為相同數字</label></Col>
                        </Row>
                    );
                }
            }
            customOpt.push(<Row key={"rnz"}><Button key={0} onClick={onCustomOptAdded}>Add</Button></Row>);

            tmp = (
                <>
                    <Form.Row>
                        <Form.Label column xs="3"></Form.Label>
                        <Col xs="9" className="text-left">
                            <Form.Check inline onChange={onRamSubSelect} checked={data.ty == 0} type="radio" name={questionIndex + "-rand-sub"} value="0" label="所有選項隨機" />
                        </Col>
                    </Form.Row>
                    <Form.Row>
                        <Form.Label column xs="3"></Form.Label>
                        <Col xs="9" className="text-left">
                            <Form.Check inline onChange={onRamSubSelect} checked={data.ty == 1} type="radio" name={questionIndex + "-rand-sub"} value="1" label="自訂選項隨機" />
                            <OverlayTrigger
                                key={"step2"}
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-step2`}>{"可設定多組選項隨機輪替 例如共有10個選項，希望1~3隨機;7~9隨機"}
                                    </Tooltip>
                                }
                            >
                                <InfoCircle style={{ marginTop: "-7px" }}></InfoCircle>
                            </OverlayTrigger>
                            <Container>{data.ty == 1 ? customOpt : null}</Container>
                        </Col>
                    </Form.Row>
                </>
            );
        }
        return (
            <Form className="mt-1">
                <Col className="text-left">
                    <Form.Check onChange={onSelect} type="radio" checked={data.is_rand == 0 || data.is_rand == "0"} name={questionIndex + "-no-rand"} value="0" label="不隨機" />
                </Col>
                <Col className="text-left">
                    <Form.Check onChange={onSelect} type="radio" checked={data.is_rand == 1 || data.is_rand == "1"} name={questionIndex + "-no-rand"} value="1" label="隨機" />
                </Col>
                {tmp}
            </Form>
        );
    }

    return render();
}
